import { useState, useEffect, useRef } from "react";
import "./AllOrder.css";
import "react-calendar/dist/Calendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";
import CalendarIcon from "../../assets/icons/CalendarBlank.svg";
import QuestionMark from "../../assets/icons/vector.svg";
import Calendar from "react-calendar";
import Select from "react-select";
import ProfileLayout from "../../components/profilelayout/ProfileLayout";
import ApiService from "../../components/Api_services";
import ReceivedNotif from "../../components/receivednotif/ReceivedNotif";
import {
  useNavigate,
  useLocation,
  Link,
  useSearchParams,
} from "react-router-dom";
import CancelOrder from "../../components/cancelorder/CancelOrder";
import PaymentMethod from "../../components/paymentmethod/PaymentMethod";
import MultiPurpose from "../../components/multipurpose/MultiPurpose.js";
import ShippingInfoPopup from "../../components/orderpopup/ShippingInfoPopup";
import CustomDropdown from "../../components/customdropdown/CustomDropdown";
import { useSelector } from "react-redux";
import { hasAccess } from "../../utils/Permission";
import { ACCESS_KEYS } from "../../constants.js";
import FallbackImg from "../../components/FallbackImg.js";

function getPagination(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);
    if (current > 4) pages.push("...");
    let start, end;
    if (current <= 4) {
      start = 2;
      end = 5;
    } else if (current >= total - 3) {
      start = total - 4;
      end = total - 1;
    } else {
      start = current - 1;
      end = current + 1;
    }
    for (let i = start; i <= end; i++) {
      if (i > 1 && i < total) pages.push(i);
    }
    if (current < total - 3) pages.push("...");
    pages.push(total);
  }
  return pages;
}

const AllOrderv1 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // Derive page, tab and type from URL
  const page = parseInt(searchParams.get("page") || "1", 10);
  const type = searchParams.get("type") || "all";
  const activeTab = type;
  const [showShippingPopup, setShowShippingPopup] = useState(
    () => !localStorage.getItem("hideShippingPopup"),
  );
  const [payingOrderNo, setPayingOrderNo] = useState(null);
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showReceivedNotif, setShowReceivedNotif] = useState(false);
  const [currentOrderNo, setCurrentOrderNo] = useState(null);
  const token = localStorage.getItem("access_token");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const ordersPerPage = 5;
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("Select here");
  const [notice, setNotice] = useState({ show: false, message: "" });
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState(""); // This triggers API
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]); // [start, end]
  const [calendarTempRange, setCalendarTempRange] = useState([null, null]);
  const inputRef = useRef(null);
  const [countdowns, setCountdowns] = useState({});
  const [autoCancelledOrders, setAutoCancelledOrders] = useState({});
  const [statusCount, setStatusCount] = useState({});

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;
  // const sub_branch_id = useSelector((state) => state.auth.user?.sub_branch) || "";
  // const subBranchIds = Array.isArray(sub_branch_id)
  // ? sub_branch_id
  // : typeof sub_branch_id === "string" && sub_branch_id.includes(",")
  // ? sub_branch_id.split(",").map((id) => id.trim()).filter(Boolean)
  // : sub_branch_id
  // ? [sub_branch_id]
  // : [];
  //refresh tab notification number
  const [refreshKey, setRefreshKey] = useState(0);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("en-MY", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const canPayOrCancel =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);

  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method);
    setShowPaymentMethod(false); // close modal if needed
  };

  const statusTypeMap = {
    all: "all",
    topay: "to_pay",
    neworder: "new",
    processing: "processing",
    toship: "shipping",
    toreceive: "to_receive",
    cancelled: "cancelled",
  };

  const [allBranchOptions, setAllBranchOptions] = useState([
    { value: "", label: "All Branch" },
  ]);

  const [selectedBranch, setSelectedBranch] = useState({
    value: "",
    label: "All Branch",
  });

  // Add this effect to sync defaults to URL
  useEffect(() => {
    const params = Object.fromEntries([...searchParams]);
    let changed = false;
    if (!params.page) {
      params.page = 1;
      changed = true;
    }
    if (!params.type) {
      params.type = "all";
      changed = true;
    }
    if (changed) {
      setSearchParams(params);
    }
  }, [searchParams, setSearchParams]);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   let changed = false;
  //   if (!params.get("tab")) {
  //     params.set("tab", "cash");
  //     changed = true;
  //   }
  //   if (!params.get("type")) {
  //     params.set("type", "all");
  //     changed = true;
  //   }
  //   if (!params.get("page")) {
  //     params.set("page", "1");
  //     changed = true;
  //   }
  //   if (changed) {
  //     // Use replace to avoid adding to browser history
  //     navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  //   }
  // }, []);

  // 通用订单获取函数
  const fetchOrders = async (
    pageNum = 1,
    branch = selectedBranch,
    searchText = search,
    range = dateRange,
  ) => {
    setLoading(true);
    setError(null);
    try {
      let params = {
        page: pageNum,
        statusType: statusTypeMap[activeTab],
      };

      params.statusType = statusTypeMap[activeTab] || "all";
      if (searchText) {
        params.search = searchText;
        params.statusType = branch.value
          ? `search_branch_${statusTypeMap[activeTab]}`
          : `search_${statusTypeMap[activeTab]}`;
      } else if (branch.value) {
        params.branch_id = branch.value;
        params.statusType = `search_branch_${statusTypeMap[activeTab]}`;
      }

      // Add date range if both dates are selected
      if (range && range[0] && range[1]) {
        const pad = (n) => n.toString().padStart(2, "0");
        const formatLocalDate = (d) =>
          `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        params.start_date = formatLocalDate(range[0]);
        params.end_date = formatLocalDate(range[1]);
      }

      const response = await ApiService.getOrderList(params);

      if (Array.isArray(response.data)) {
        setOrderList(response.data);
        setTotalOrders(
          response.pagination?.total_records || response.data.length,
        );
      } else if (Array.isArray(response)) {
        setOrderList(response);
        setTotalOrders(response.length);
      } else {
        setOrderList([]);
        setTotalOrders(0);
        setError("No order data found.");
      }
    } catch (error) {
      setError("An error occurred while fetching orders.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Update countdowns every second
    const timer = setInterval(() => {
      setCountdowns((prev) => {
        const updated = {};
        orderList.forEach((order) => {
          updated[order.order_no] = getTimeLeft(order.expiry_date);
        });
        return updated;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [orderList]);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      let data;
      // if (is_subuser && subBranchIds.length > 0) {
      //   // 只查 subuser 的所有分行
      //   data = await ApiService.getBranchList({ branch_id: subBranchIds });
      // } else {
      //   data = await ApiService.getBranchList();
      // }
      data = await ApiService.getBranchList();
      if (Array.isArray(data)) {
        const options = data.map((item) => ({
          value: item.branch_id,
          label: item.branch_code,
        }));
        setAllBranchOptions([{ value: "", label: "All Branch" }, ...options]);
        // 如果是 subuser，默认选中所有自己的分行
        // if (is_subuser && subBranchIds.length > 0) {
        //   // 只选第一个分行为默认
        //   setSelectedBranch(
        //     options.find((opt) => subBranchIds.includes(opt.value)) ||
        //       { value: subBranchIds[0], label: subBranchIds[0] }
        //   );
        // }
      }
    } catch (err) {
      console.error("Error fetching branch list:", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    // Update URL to page 1
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const clearSearch = () => {
    setSearchInput("");
    setSearch("");
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    if (searchInput === "") {
      setSearch("");
    }
  }, [searchInput]);

  const handleOrderClick = (order, e) => {
    // Prevent default if order_no is missing
    if (!order.order_no) {
      e.preventDefault();
      console.error("Missing order_no for:", order);
      return;
    }

    // Optional: Log the navigation
    // console.log(`Navigating to order: ${order.order_no}`);
  };

  const handleBranchChange = (selectedOption) => {
    setSelectedBranch(selectedOption);
    // Update URL to page 1
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const handlePageChange = (newPage) => {
    setShowReceivedNotif(false);
    // Update the URL with the new page parameter
    const params = new URLSearchParams(location.search);
    params.set("page", newPage);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const isSelectable = (order) => {
    return order.can_pay_now;
  };
  const selectableOrders = orderList.filter(isSelectable);

  const handleSelect = (orderNo) => {
    setSelectedOrders((prev) =>
      prev.includes(orderNo)
        ? prev.filter((no) => no !== orderNo)
        : [...prev, orderNo],
    );
  };

  const handleSelectAll = (e) => {
    const currentPageOrderNos = selectableOrders.map((order) => order.order_no);
    if (e.target.checked) {
      setSelectedOrders((prev) =>
        Array.from(new Set([...prev, ...currentPageOrderNos])),
      );
    } else {
      setSelectedOrders((prev) =>
        prev.filter((no) => !currentPageOrderNos.includes(no)),
      );
    }
  };

  const calculateTotal = () => {
    // Get total price from all selected orders
    return orderList
      .filter((order) => selectedOrders.includes(order.order_no))
      .reduce((total, order) => {
        // Extract numeric value from price strings like "RM 7,208.00"
        const priceStr = order.total_price || "0";
        const numericPrice = parseFloat(priceStr) || 0;
        return total + numericPrice;
      }, 0)
      .toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  };

  // Handle paying selected orders
  const handlePaySelectedOrders = () => {
    if (!selectedPaymentMethod || selectedPaymentMethod === "Select here") {
      setNotice({ show: true, message: "Please select a payment method." });
      return;
    }

    const selectedOrdersData = orderList.filter((order) =>
      selectedOrders.includes(order.order_no),
    );

    const orderIds = selectedOrders.join(",");
    const totalAmount = calculateTotal();

    let paymentType = "cheque";
    if (selectedPaymentMethod === "Online Banking") {
      paymentType = "online_banking";
    } else if (selectedPaymentMethod === "FPX") {
      paymentType = "fpx";
    }

    // Navigate to UploadCheque page with proper parameters
    navigate(`/uploadcheque?orders=${orderIds}&type=${paymentType}`);
  };

  // Handle cancelling selected orders
  const handleCancelSelectedOrders = () => {
    if (selectedOrders.length === 0) return;
    setShowCancelOrderModal(true);
  };

  const handleCancelSuccess = async () => {
    try {
      // Clear selection
      setSelectedOrders([]);
      // Refresh order counts in tabs
      setRefreshKey((prev) => prev + 1);

      // Redirect to Cash/To Pay tab if we're not already there
      if (type !== "topay") {
        navigate("/allorder?type=topay");
      } else {
        // Just refresh the current list if we're already on the right tab
        fetchOrders(1, selectedBranch, search);
      }
    } catch (error) {
      console.error("Error handling cancel success:", error);
    }
  };

  // Handler for range selection
  const handleDateRangeChange = (range) => {
    setDateRange(range);
    setCalendarOpen(false);
    // Optionally trigger fetchOrders here with range[0] and range[1]
  };

  function parseExpiryDate(expiryDateStr) {
    if (!expiryDateStr) return null;
    // Convert "2025-09-16 12 a.m." to "2025-09-16 00:00"
    let str = expiryDateStr.trim();

    // Handle "12 a.m." as 00:00 and "12 p.m." as 12:00
    const match = str.match(/^(\d{4}-\d{2}-\d{2}) (\d{1,2}) (a\.m\.|p\.m\.)$/i);
    if (match) {
      let [_, date, hour, period] = match;
      hour = parseInt(hour, 10);
      let hour24 = hour;
      if (period.toLowerCase() === "a.m.") {
        hour24 = hour === 12 ? 0 : hour;
      } else if (period.toLowerCase() === "p.m.") {
        hour24 = hour === 12 ? 12 : hour + 12;
      }
      str = `${date} ${hour24.toString().padStart(2, "0")}:00:00`;
    } else {
      // fallback: replace " a.m."/" p.m." with " AM"/" PM" for Date parsing
      str = str.replace(" a.m.", " AM").replace(" p.m.", " PM");
    }

    const date = new Date(str);
    if (isNaN(date.getTime())) return null;
    return date;
  }

  function getTimeLeft(expiryDate) {
    const expiry = parseExpiryDate(expiryDate);
    if (!expiry) return { h: "00", m: "00", s: "00", expired: true };
    const now = new Date();
    const diff = expiry - now;
    if (diff <= 0) return { h: "00", m: "00", s: "00", expired: true };
    const h = String(Math.floor(diff / 1000 / 60 / 60)).padStart(2, "0");
    const m = String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0");
    const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
    return { h, m, s, expired: false };
  }

  // Auto-cancel function
  const handleAutoCancelOrder = async (orderNo) => {
    const order = orderList.find((o) => o.order_no === orderNo);
    if (
      !orderNo ||
      autoCancelledOrders[orderNo] ||
      !["To Pay", "To Pay - Failed"].includes(order.status_label)
    )
      return;

    try {
      const response = await ApiService.cancelOrders(orderNo);
      if (response && response.status) {
        setAutoCancelledOrders((prev) => ({ ...prev, [orderNo]: true }));
        setNotice({
          show: true,
          message: `Order ${orderNo} has expired and been automatically cancelled.`,
        });
        // Optionally refresh orders
        fetchOrders(page, selectedBranch, search, dateRange);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error auto-cancelling order:", error);
    }
  };

  useEffect(() => {
    orderList.forEach((order) => {
      const countdown = countdowns[order.order_no];
      if (
        countdown?.expired &&
        !autoCancelledOrders[order.order_no] &&
        order.status_label === "To Pay"
      ) {
        handleAutoCancelOrder(order.order_no);
      }
    });
  }, [countdowns, orderList]);

  // Watch countdowns and auto-cancel expired orders
  // useEffect(() => {
  //   if (activeTab !== "topay") return;
  //   orderList.forEach((order) => {
  //     const countdown = countdowns[order.order_no];
  //     // Only auto-cancel if status is 'to_pay'
  //     if (
  //       countdown?.expired &&
  //       !autoCancelledOrders[order.order_no] &&
  //       (order.payment_status === "to_pay" ||
  //         order.payment_status === "to_pay_pending" ||
  //         order.payment_status === "to_pay_unsuccessful")
  //     ) {
  //       handleAutoCancelOrder(order.order_no);
  //     }
  //   });
  //   // eslint-disable-next-line
  // }, [countdowns, activeTab, orderList]);

  useEffect(() => {
    setNotice({ show: false, message: "" }); // Reset notice
    setAutoCancelledOrders({}); // Reset cancelled orders tracking
    fetchOrders(page, selectedBranch, search, dateRange);
  }, [activeTab, page, selectedBranch, search, dateRange]);

  useEffect(() => {
    const fetchCounts = async () => {
      const data = await ApiService.getOrderStatusCount();
      setStatusCount(data);
    };
    fetchCounts();
  }, [refreshKey]);

  const handleTabChange = (tab) => {
    setSearchInput("");
    setSearch("");
    setDateRange(null);
    setCalendarTempRange([null, null]);
    setCalendarOpen(false);
    const params = new URLSearchParams(searchParams);
    params.set("type", tab);
    params.set("page", "1");
    setSearchParams(params, { replace: true });
  };

  return (
    <ProfileLayout>
      <div className="allorder">
        <div className="allorder-content">
          {notice.show && (
            <MultiPurpose
              title="Notice"
              message={notice.message}
              yesText="OK"
              showYesLink={false}
              hideNo={true}
              onYes={() => setNotice({ show: false, message: "" })}
              onNo={() => setNotice({ show: false, message: "" })}
              onClose={() => setNotice({ show: false, message: "" })}
            />
          )}

          {/* {showShippingPopup && (
            <ShippingInfoPopup onClose={() => setShowShippingPopup(false)} />
          )} */}

          <div className="myorder-title">
            <strong>MY ORDER</strong>
          </div>

          {canPayOrCancel ? (
            <>
              <div className="allorder-main">
                {/* MyOrder Top Navigation Bar */}
                <div className="myordernav">
                  <div className="uppertab">
                    <div
                      className={`alltab${type === "all" ? " active-tab" : ""}`}
                      onClick={() => handleTabChange("all")}
                    >
                      All
                    </div>

                    <div
                      className={`newordertab${type === "neworder" ? " active-tab" : ""}`}
                      onClick={() => handleTabChange("neworder")}
                    >
                      New Order
                    </div>
                    <div
                      className={`unread${statusCount.to_pay > 0 ? " show" : ""}`}
                    >
                      ({statusCount.to_pay})
                    </div>

                    <div
                      className={`processingtab${
                        type === "processing" ? " active-tab" : ""
                      }`}
                      onClick={() => handleTabChange("processing")}
                    >
                      Processing
                    </div>

                    <div
                      className={`toshiptab${type === "toship" ? " active-tab" : ""}`}
                      onClick={() => handleTabChange("toship")}
                    >
                      Shipping
                    </div>

                    <div
                      className={`toreceivetab${type === "toreceive" ? " active-tab" : ""}`}
                      onClick={() => handleTabChange("toreceive")}
                    >
                      Received
                    </div>
                    <div
                      className={`unread${statusCount.received > 0 ? " show" : ""}`}
                    >
                      ({statusCount.received})
                    </div>

                    <div
                      className={`cancelledtab${type === "cancelled" ? " active-tab" : ""}`}
                      onClick={() => handleTabChange("cancelled")}
                    >
                      Cancelled
                    </div>
                  </div>
                </div>
              </div>

              <div className="allorder-line"></div>

              <div className="allorder-sub">
                <form onSubmit={handleSearch} className="searchbar-allorder">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    style={{
                      color: "#798777",
                      fontSize: "18px",
                    }}
                  />
                  <input
                    placeholder="Search by Order No, Item Code, Item Name"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  {searchInput && (
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={clearSearch}
                      style={{
                        color: "#798777",
                        fontSize: "16px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                    />
                  )}
                </form>

                {/* Date Picker */}
                <form
                  className="ao-date-picker-container"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (calendarTempRange?.[0] && calendarTempRange?.[1]) {
                      handleDateRangeChange(calendarTempRange);
                    }
                  }}
                >
                  <input
                    ref={inputRef}
                    type="text"
                    className="ao-date-range-input"
                    value={
                      calendarTempRange?.[0]
                        ? `${new Date(calendarTempRange[0]).toLocaleDateString(
                            "en-MY",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )} - ${
                            calendarTempRange[1]
                              ? new Date(
                                  calendarTempRange[1],
                                ).toLocaleDateString("en-MY", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                              : "End Date"
                          }`
                        : "Select Date Range"
                    }
                    onClick={() => setCalendarOpen((open) => !open)}
                    readOnly
                  />
                  {(calendarTempRange?.[0] || calendarTempRange?.[1]) && (
                    <FontAwesomeIcon
                      icon={faTimes}
                      style={{
                        marginLeft: 8,
                        color: "#aaa",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCalendarTempRange([null, null]);
                        setDateRange([null, null]);
                        setCalendarOpen(false);
                      }}
                    />
                  )}
                  <FallbackImg
                    src={CalendarIcon}
                    alt="calendar"
                    width="22"
                    height="22"
                    style={{ cursor: "pointer" }}
                    onClick={() => setCalendarOpen((open) => !open)}
                  />
                  {calendarOpen && (
                    <div className="allorder-calendar">
                      <Calendar
                        selectRange
                        onChange={(range) => {
                          setCalendarTempRange(range);
                          // Focus input after two dates are picked
                          if (range?.[0] && range?.[1] && inputRef.current) {
                            inputRef.current.focus();
                          }
                          setCalendarOpen(false);
                        }}
                        value={calendarTempRange}
                        maxDate={new Date()}
                      />
                    </div>
                  )}
                  {/* Hidden submit button to allow Enter key to trigger onSubmit */}
                  <button
                    type="submit"
                    style={{ display: "none" }}
                    tabIndex={-1}
                  ></button>
                </form>

                <CustomDropdown
                  options={allBranchOptions}
                  value={selectedBranch.value}
                  onChange={(val, opt) => handleBranchChange(opt)}
                  placeholder="All Branch"
                  className="allorder-dropdown"
                />
              </div>

              {activeTab === "topay" && (
                <div
                  className="selectall"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                    margin: "10px 20px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={
                      selectableOrders.length > 0 &&
                      selectableOrders.every((order) =>
                        selectedOrders.includes(order.order_no),
                      )
                    }
                    onChange={handleSelectAll}
                    disabled={selectableOrders.length === 0}
                  />
                  <div>
                    Select All ({selectableOrders.length}) | Selected :{" "}
                    {selectedOrders.length}
                  </div>
                </div>
              )}

              <div className="allorder-sub2">
                {orderList.length === 0 && loading ? (
                  <p>Loading orders...</p>
                ) : error ? (
                  <p style={{ color: "red" }}>{error}</p>
                ) : orderList.length === 0 ? (
                  <p>No orders found.</p>
                ) : (
                  orderList.map((order, index) => (
                    <div key={order.order_no || index}>
                      <Link
                        to={`/orderdetail/${order.order_no}?type=${type}${
                          order.can_pay_now ? "&canpay" : "&cannotpay"
                        }`}
                        onClick={(e) => handleOrderClick(order, e)}
                        className="allorder-item"
                      >
                        <div style={{ display: "inline-block" }}>
                          {isSelectable(order) ? (
                            <input
                              type="checkbox"
                              checked={selectedOrders.includes(order.order_no)}
                              onChange={() =>
                                canPayOrCancel && handleSelect(order.order_no)
                              }
                              onClick={(e) => e.stopPropagation()}
                              disabled={!canPayOrCancel}
                              style={{
                                cursor: canPayOrCancel
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              title={canPayOrCancel ? "" : "No permission"}
                            />
                          ) : (
                            <div
                              style={{ width: 25, display: "inline-block" }}
                            ></div>
                          )}
                        </div>

                        <div className="aoitem-leftcenter-container">
                          <div className="aoitem-tag-main">
                            <div
                              className={`aoitem-tag ${order.status_label
                                ?.toLowerCase()
                                .replace(/\s/g, "")}`}
                            >
                              {order.status_label === "To Pay" ||
                              order.status_label === "To Pay - Processing" ||
                              order.status_label === "To Pay - Failed"
                                ? order.payment_status === "to_pay_pending"
                                  ? "Pending"
                                  : order.payment_status ===
                                      "to_pay_unsuccessful"
                                    ? "Unsuccessful"
                                    : "To Pay"
                                : order.status_label}
                            </div>

                            {/* {activeTab === "topay" && ( */}
                            {["To Pay", "To Pay - Failed"].includes(
                              order.status_label,
                            ) && (
                              <div className="ao-orderclose">
                                <div className="ao-orderclose-caption">
                                  Order will close in
                                </div>
                                <div className="ao-orderclose-cdtimer">
                                  {countdowns[order.order_no]?.expired ? (
                                    <span className="ao-orderclose-expired">
                                      Expired
                                    </span>
                                  ) : (
                                    <>
                                      <div className="ao-orderclose-time">
                                        {countdowns[order.order_no]?.h || "00"}
                                      </div>
                                      <div>:</div>
                                      <div className="ao-orderclose-time">
                                        {countdowns[order.order_no]?.m || "00"}
                                      </div>
                                      <div>:</div>
                                      <div className="ao-orderclose-time">
                                        {countdowns[order.order_no]?.s || "00"}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}

                            {activeTab === "toship" && (
                              <>
                                <div>
                                  <span className="aoitem-received-info">
                                    Status changes to{" "}
                                    <span className="aoitem-received-info-highlight">
                                      <b>Received</b>
                                    </span>{" "}
                                    after set days
                                  </span>
                                </div>
                                <div className="ao-quesmark-tooltip-container">
                                  <FallbackImg
                                    src={QuestionMark}
                                    alt="questionmark"
                                    width="16"
                                    height="16"
                                  />
                                  <div className="ao-quesmark-tooltip-text">
                                    <table>
                                      <tr>
                                        <td>Kuala Lumpur and Selangor</td>
                                        <td>:</td>
                                        <td>7 working days</td>
                                      </tr>
                                      <tr>
                                        <td>Other States</td>
                                        <td>:</td>
                                        <td>14 working days</td>
                                      </tr>
                                      <tr>
                                        <td>East Malaysia</td>
                                        <td>:</td>
                                        <td>45 working days</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          <div style={{ display: "flex" }}>
                            <div className="aoitem-left">
                              <div className="aoitem-orderno">
                                <span className="aoitem-subtitle">
                                  Order No
                                </span>
                                <div className="aoitem-colon">:</div>
                                <div className="aoitem-value">
                                  {order.order_no ? order.order_no : "-"}
                                </div>
                              </div>
                              <div className="aoitem-date">
                                <span className="aoitem-subtitle">
                                  Order Date
                                </span>
                                <div className="aoitem-colon">:</div>
                                <div className="aoitem-value">
                                  {order.created_date
                                    ? formatDate(order.created_date)
                                    : "-"}
                                </div>
                              </div>
                            </div>
                            <div className="aoitem-center">
                              <div className="aoitem-total">
                                <span className="aoitem-subtitle">Total</span>
                                <div className="aoitem-colon">:</div>
                                <div className="aoitem-value-total">
                                  <div className="aoitem-RM">RM</div>
                                  {order.total_price
                                    ? formatCurrency(order.total_price)
                                    : "0.00"}
                                </div>
                              </div>
                              <div className="aoitem-delivery">
                                <span className="aoitem-subtitle">
                                  Ship To{" "}
                                </span>
                                <div className="aoitem-colon">:</div>
                                <div className="aoitem-value-delivery">
                                  {/* {Array.isArray(order.delivery) &&
                              order.delivery.length > 0
                                ? order.delivery.length === 2
                                  ? // If exactly two branches
                                    `${
                                      order.delivery[0] &&
                                      order.delivery[0].length > 15
                                        ? order.delivery[0].slice(0, 15) + "…"
                                        : order.delivery[0]
                                    } and 1 branch`
                                  : order.delivery.length >= 3
                                  ? `${
                                      order.delivery[0] &&
                                      order.delivery[0].length > 15
                                        ? order.delivery[0].slice(0, 15) + "…"
                                        : order.delivery[0]
                                    } and ${order.delivery.length - 1} branches`
                                  : // If only one branch
                                  order.delivery[0] &&
                                    order.delivery[0].length > 15
                                  ? order.delivery[0].slice(0, 15) + "…"
                                  : order.delivery[0]
                                : // Not an array or empty
                                Array.isArray(order.delivery) &&
                                  order.delivery.length === 0
                                ? "-"
                                : order.delivery} */}

                                  {Array.isArray(order.delivery) &&
                                  order.delivery.length > 0
                                    ? order.delivery.length === 1
                                      ? "1 branch"
                                      : `${order.delivery.length} branches`
                                    : "-"}
                                </div>
                              </div>
                              {/* <div className="aoitem-payment">
                            <span className="aoitem-subtitle">Payment by</span>
                            <div className="aoitem-colon">:</div>
                            <div className="aoitem-value">
                              {order.payment_method}
                            </div>
                          </div> */}
                            </div>
                          </div>
                        </div>

                        <div className="aoitem-right">
                          {order.can_pay_now &&
                            (order.payment_status === "to_pay" ||
                              order.payment_status ===
                                "to_pay_unsuccessful") && (
                              <button
                                className="aoitem-button"
                                onClick={(e) => {
                                  if (!canPayOrCancel) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setPayingOrderNo(order.order_no);
                                  setShowPaymentMethod(true);
                                }}
                                disabled={!canPayOrCancel}
                                style={{
                                  opacity: canPayOrCancel ? 1 : 0.5,
                                  cursor: canPayOrCancel
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                title={canPayOrCancel ? "" : "No permission"}
                              >
                                PAY NOW
                              </button>
                            )}
                          {order.status_label === "Shipping" && (
                            <button
                              className="aoitem-button-toreceive"
                              onClick={(e) => {
                                if (!canPayOrCancel) {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  return;
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                setCurrentOrderNo(order.order_no);
                                setShowReceivedNotif(true);
                              }}
                              disabled={!canPayOrCancel}
                              style={{
                                opacity: canPayOrCancel ? 1 : 0.5,
                                cursor: canPayOrCancel
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              title={canPayOrCancel ? "" : "No permission"}
                            >
                              RECEIVED
                            </button>
                          )}
                        </div>

                        <div className="ao-nextsign">&gt;</div>
                      </Link>
                    </div>
                  ))
                )}
                <div className="pagination-modern">
                  <button
                    className="pagination-btn"
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    <span className="arrow">&lt;</span>
                    <span className="prevnext-text">Prev</span>
                  </button>
                  {getPagination(
                    page,
                    Math.ceil(totalOrders / ordersPerPage),
                  ).map((p, idx) =>
                    p === "..." ? (
                      <span
                        key={`ellipsis-${idx}`}
                        className="pagination-ellipsis"
                      >
                        ...
                      </span>
                    ) : (
                      <button
                        key={`page-${p}-${idx}`}
                        className={`pagination-btn${
                          page === p ? " pagination-current" : ""
                        }`}
                        onClick={() => handlePageChange(p)}
                        disabled={page === p}
                      >
                        {p}
                      </button>
                    ),
                  )}
                  <button
                    className="pagination-btn"
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === Math.ceil(totalOrders / ordersPerPage)}
                  >
                    <span className="prevnext-text">Next</span>
                    <span className="arrow">&gt;</span>
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span style={{ color: "#b71c1c", fontWeight: 600 }}>
                You do not have permission to view My Order.
              </span>
            </div>
          )}
          {showReceivedNotif && (
            <ReceivedNotif
              onClose={() => setShowReceivedNotif(false)}
              onConfirm={async () => {
                if (currentOrderNo) {
                  await ApiService.confirmReceive(currentOrderNo);
                  setShowReceivedNotif(false);
                  setCurrentOrderNo(null);
                  fetchOrders(page, selectedBranch, search);
                  setRefreshKey((k) => k + 1);
                }
              }}
            />
          )}
        </div>

        {selectedOrders.length > 0 && (
          <div className="orders-footer">
            <div className="orders-footer-line"></div>

            <div className="orders-footer-content">
              <div className="selected-section">
                <div className="orders-footer-selected">
                  {selectedOrders.length} Selected
                  {selectedOrders.length > 0 && (
                    <span
                      className="clearall-btn"
                      onClick={() => setSelectedOrders([])}
                    >
                      Clear All
                    </span>
                  )}
                </div>
              </div>

              <div className="payment-section">
                <div className="orders-footer-paymentby">Payment By :</div>
                <div className="orders-footer-payment-container">
                  <label className="orders-footer-payment">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="FPX"
                      checked={selectedPaymentMethod === "FPX"}
                      onChange={() => setSelectedPaymentMethod("FPX")}
                    />
                    <span>FPX</span>
                  </label>

                  <label className="orders-footer-payment">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="Online Banking"
                      checked={selectedPaymentMethod === "Online Banking"}
                      onChange={() =>
                        setSelectedPaymentMethod("Online Banking")
                      }
                    />
                    <span>IBG</span>
                  </label>
                </div>
              </div>

              <div className="footer-actions">
                <div className="orders-footer-total">
                  Total : <br />
                  <strong>
                    <div className="orders-footer-RM">RM</div>
                    {calculateTotal()}
                  </strong>
                </div>

                <button
                  className="cancel-order-btn"
                  onClick={handleCancelSelectedOrders}
                >
                  Cancel
                </button>
                <button
                  className="pay-now-btn"
                  onClick={handlePaySelectedOrders}
                  disabled={!selectedPaymentMethod}
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        )}
        {showPaymentMethod && (
          <PaymentMethod
            // onlyFPX={tab === "term"}
            onClose={() => {
              setShowPaymentMethod(false);
              setPayingOrderNo(null); // Clear the paying order when modal is closed
            }}
            onSelect={(method) => {
              // Handle both bulk and individual payments
              setSelectedPaymentMethod(method);
              setShowPaymentMethod(false);

              // If paying a single order, navigate directly
              if (payingOrderNo) {
                const orderData = orderList.find(
                  (order) => order.order_no === payingOrderNo,
                );
                if (orderData) {
                  const amount = orderData.total_price;
                  let paymentType = "cheque";

                  if (method === "Online Banking") {
                    paymentType = "online_banking";
                  } else if (method === "FPX") {
                    paymentType = "fpx";
                  }

                  navigate(
                    `/uploadcheque?orders=${payingOrderNo}&type=${paymentType}`,
                  );
                }
                setPayingOrderNo(null);
              }
            }}
          />
        )}
        {showCancelOrderModal && (
          <CancelOrder
            orderId={selectedOrders} // Pass all selected orders
            onClose={() => setShowCancelOrderModal(false)}
            onSuccess={handleCancelSuccess}
          />
        )}
      </div>
    </ProfileLayout>
  );
};

export default AllOrderv1;
